import { GeoJsonLineWithHalo } from "./GeoJsonLineWithHalo";
import {
    useRouteResponse,
    useSelectedRouteIndex,
} from "../../stores/RouteStore";
import { DashedSnapLine } from "./DashedSnapLine";

export default function SelectedRoute() {
    const routeResponse = useRouteResponse();
    const selectedRouteIndex = useSelectedRouteIndex();

    if (!routeResponse || routeResponse.routes.length === 0) {
        return <></>;
    }

    return (
        <>
            <GeoJsonLineWithHalo
                key={routeResponse.routes[selectedRouteIndex].routeId}
                data={routeResponse.routes[selectedRouteIndex]}
                color={
                    routeResponse.routes[selectedRouteIndex].isObstructed
                        ? "#FD0A0A"
                        : "#4d79ff"
                }
                haloColor="#000000"
                weight={5}
            />
            <DashedSnapLine route={routeResponse.routes[selectedRouteIndex]}/>
        </>
    );
}
